import PropTypes from 'prop-types';
import React from 'react';
import ReactList from 'react-list';

const InfiniteList = ({ length, itemRenderer, ...otherProps }) =>
  <ReactList {...otherProps} itemRenderer={itemRenderer} type={'simple'} length={length} useTranslate3d/>;

InfiniteList.propTypes = {
  length: PropTypes.number.isRequired,
  itemRenderer: PropTypes.func.isRequired,
};

export default InfiniteList;



// WEBPACK FOOTER //
// ./app/components/infinite-list/infinite-list.js